module.exports = __webpack_public_path__ + "static/media/TacoLogo.5b21b759.svg";